import { Button } from '@mui/material';
import styled from 'styled-components';
import { Colors } from '../../../../../../constants/Colors';

export const ActiveItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin: 24px;
`;

const LineItem = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const LineItems = styled(LineItem)`
  gap: 47px;
`;

export const LineItemsSecondary = styled(LineItem)`
  margin-top: 24px;
  gap: 24px;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  gap: 8px;
`;

export const Title = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const DateText = styled.span`
  color: var(--luft-primary);
  font-size: 16px;
  font-weight: 400;
`;

export const Value = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
`;

export const StyledButton = styled(Button)`
  padding: 8px 11px;
  color: var(--luft-primary);
  gap: 8px;
  font-family: 'Work Sans';
  font-size: 15px;
  font-weight: 500;
`;

export const AccessMapButton = styled(Button)`
  padding: 8px 22px;
  text-transform: none;
  font-family: "Work Sans"; 
  font-size: 15px; 
  font-weight: 500;
  gap: 8px;
  background-color: var(--luft-primary);
  
  &:hover {
    background-color: ${Colors.PRIMARY_LIGHT_DARK};
  }
`;
